import React, { useRef } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

/*
    Carrossel de imagens com autoplay (quando há mais de uma) e setas pretas
    nas laterais, posicionadas FORA da imagem (no gutter), já que as imagens
    costumam ser claras e deixavam os dots brancos pouco visíveis.
*/
const setaStyle = (lado) => ({
	position: "absolute",
	top: "50%",
	transform: "translateY(-50%)",
	[lado]: 0,
	zIndex: 2,
	background: "transparent",
	border: "none",
	cursor: "pointer",
	color: "#000",
	fontSize: 22,
	lineHeight: 1,
	padding: 4,
});

const CarrosselImagens = ({ imagens, style }) => {
	const ref = useRef(null);

	if (!Array.isArray(imagens) || imagens.length === 0) {
		return null;
	}

	const varias = imagens.length > 1;

	return (
		<div
			style={{
				position: "relative",
				padding: varias ? "0 36px" : 0,
				...style,
			}}
		>
			{varias && (
				<button
					type="button"
					aria-label="Imagem anterior"
					onClick={() => ref.current && ref.current.prev()}
					style={setaStyle("left")}
				>
					<LeftOutlined />
				</button>
			)}

			<Carousel
				ref={ref}
				autoplay={varias}
				autoplaySpeed={4000}
				draggable
				dots={varias}
			>
				{imagens.map((src, i) => (
					<div key={i}>
						<img
							src={src}
							alt=""
							style={{
								width: "100%",
								maxHeight: "60vh",
								objectFit: "contain",
								borderRadius: 8,
							}}
						/>
					</div>
				))}
			</Carousel>

			{varias && (
				<button
					type="button"
					aria-label="Próxima imagem"
					onClick={() => ref.current && ref.current.next()}
					style={setaStyle("right")}
				>
					<RightOutlined />
				</button>
			)}
		</div>
	);
};

export default CarrosselImagens;
